import React from 'react'
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react'
import { useConfiguration } from './providers/ConfigurationContext'
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import { initializeAppInsights } from '../monitoring/AppInsights'
import { FeatureFlagsProvider } from './providers/FeatureFlagContext'
import { LoginPage } from '../pages/LoginPage'
import AppRouter from './AppRouter'
import { ColorModeProvider } from '../design/ColorModeProvider'
const App: React.FC = () => {
  const config = useConfiguration()
  const { reactPlugin } = initializeAppInsights(
    config.applicationInsightsConnectionString
  )
  return (
    <div className="App">
      <header className="App-header"></header>
      <React.Fragment>
        {/* v1 stays on default MUI (no design-system theme) so the existing
            site and its e2e suite are unaffected. The design system is opted
            into only on the /design-system route and the login screen below;
            the upcoming /v2 AppShell adds it scoped to its own subtree. */}
        <AuthenticatedTemplate>
          <FeatureFlagsProvider>
            <AppInsightsContext.Provider value={reactPlugin}>
              <AppRouter />
            </AppInsightsContext.Provider>
          </FeatureFlagsProvider>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <ColorModeProvider>
            <LoginPage>
              <></>
            </LoginPage>
          </ColorModeProvider>
        </UnauthenticatedTemplate>
      </React.Fragment>
    </div>
  )
}

export default App
